/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Link } from 'react-router-dom-v5-compat'
import { useDeviceMediaQuery } from '../../Shared/UseDeviceMediaQuery/useDeviceMediaQuery'
import { Label } from 'semantic-ui-react'

const OrderStatusLabel = ({active, count, label, linkTo}) => {
    const {isMobile} = useDeviceMediaQuery()

    return (
      <Link
        css={css`
            display: flex;
            justify-content: center;
            align-items: center;
            column-gap: .5rem;
            color: unset;
            padding: .3rem;
            background-color: transparent;
            -webkit-tap-highlight-color: transparent;

            ${isMobile && `
                border: 1px solid lightgrey;
                border-radius: 3px;
            `}
            ${active && `
                    border-bottom: 2px solid black;
                    font-weight: 700;
                `}
            :hover {
                color: unset;
                ${active && `
                    border-bottom: 2px solid black;
                `}
            }
        `}
        to={linkTo}
        basic
      >
          {(count > 0) ? (
              <>
                  <Label
                    color="teal"
                    circular
                  >
                      {count}
                  </Label>
                  <span>{label}</span>
              </>
            ) :
            (
              <span>{label}</span>
            )}

      </Link>
    )
}

export { OrderStatusLabel }
